import React from 'react';
import ReactDOM from 'react-dom/client';

import PodcastList from './components/PodcastList';

const podcastListEn = document.getElementById('podcast-list-en');
if (podcastListEn !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListEn);
  selectDiv.render(
    <>
      <PodcastList language="en" />
    </>
  );  
}


const podcastListEs = document.getElementById('podcast-list-es');
if (podcastListEs !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListEs);
  selectDiv.render(
    <>
      <PodcastList language="es" />
    </>
  );  
}


const podcastListPt = document.getElementById('podcast-list-pt');
if (podcastListPt !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListPt);
  selectDiv.render(
    <>
      <PodcastList language="pt" />
    </>
  );  
}

const podcastListFa = document.getElementById('podcast-list-fa');
if (podcastListFa !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListFa);
  selectDiv.render(
    <>
      <PodcastList language="fa" />
    </>
  );  
}

const podcastListFr = document.getElementById('podcast-list-fr');
if (podcastListFr !== null) {
  const selectDiv = ReactDOM.createRoot(podcastListFr);
  selectDiv.render(
    <>
      <PodcastList language="fr" />
    </>
  );  
}
